<script>
    import {DateInput} from 'date-picker-svelte';
    import {start_date, end_date, start_date_string, end_date_string} from '$lib/store.js';

    export const date_locale = {
        'weekdays': ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'],
        'months': ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december']
    };

    // We have to convert the $start_date and $end_date date objects to
    // strings, because using objects in store variables can result in
    // them triggering twice
    $: {
        if ($start_date) {
            $start_date_string = $start_date.toISOString();
        } else {
            $start_date_string = '';
        }

        if ($end_date) {
            $end_date_string = $end_date.toISOString();
        } else {
            $end_date_string = '';
        }
    }
</script>

<h3>Periode</h3>

<div style="margin-top: 20px; margin-bottom: 30px;">
    <DateInput format="dd/MM/yyyy" placeholder="startdatum" closeOnSelection=true locale={date_locale} bind:value={$start_date}/>
    <div id="date-field-seperator"></div>
    <DateInput format="dd/MM/yyyy" placeholder="einddatum" closeOnSelection=true locale={date_locale} bind:value={$end_date}/>
</div>

<style lang="scss">
    h3 {
        font-size: 20px !important;
        line-height: 20.8px !important;
        margin-bottom: 17px !important;
    }

    #date-field-seperator {
        display: inline-block;
        position: relative;
        top: -6px;
        height: 2px;
        width: 20px;
        background-color: var(--dark-blue-color);
        margin-left: 4px;
        margin-right: 4px;
    }

    :root {
        --date-input-width: 130px;
    }

    :global(.date-time-field) {
        display: inline-block !important;

        :global(input) {
            height: 50px !important;
            line-height: 22px !important;
            padding: 15px 20px 15px 20px !important;
            border-radius: 40px !important;
            border-color: var(--light-blue-color5) !important;
            color: var(--dark-blue-color) !important;
            font-weight: 600 !important;
            text-align: center;

            &::placeholder {
                font-weight: 400 !important;
            }
        }
    }

    :global(.date-time-picker) {
        border-radius: 15px !important;
        padding: 30px !important;
    }

    :global(.date-time-field:nth-of-type(3) .picker) {
        left: -156px;
    }
</style>
